module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-div"
  }, [_c('img', {
    attrs: {
      "src": "/static/geopsicon.gif",
      "height": "40",
      "width": "40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "indications"
  }, [_c('h1', [_vm._v("404 - Seite wurde nicht gefunden")]), _vm._v("\n    Die angeforderte Seite „" + _vm._s(_vm.baseUrl) + _vm._s(_vm.url) + "“ wurde nicht gefunden.\n  ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://geops.ch/impressum"
    }
  }, [_vm._v("geOps Kontakt")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d7e1976","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/PageNotFound.vue
// module id = 419
// module chunks = 1